import React from "react";

import {
  StyledBoxHeight,
  StyledBoxImage,
  StyledHeading,
  StyledImage,
  StyledSpan,
} from "./style";

const AuthImage = () => {
  return (
    <>
      <StyledBoxImage>
        <StyledBoxHeight>
          <StyledImage />
          <StyledHeading>
            Connection NRIs
            <br />
            <StyledSpan>
              to their roots <br /> effortlessly
            </StyledSpan>
          </StyledHeading>
        </StyledBoxHeight>
      </StyledBoxImage>
    </>
  );
};

export default AuthImage;
